import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router";
import Dashboard from './pages/dashboard/dashboard';
import Login from './pages/login/login';
import './app.css'
import Patients from './components/Patients';
import Medecins from './components/Medecins';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/patients" element={<Patients />} />
      <Route path="/medecins" element={<Medecins />} />
    </Routes>
</BrowserRouter>

);